import React, {useEffect} from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import hash from '../../helpers/hash';
import config from '../../helpers/config';


const useStyles = makeStyles(theme => ({

    pageCoverSection: props => ({
        position: 'relative',
        height: `${hash.walk('imgHeight.xl', props) || '100vh'}`,
        [theme.breakpoints.down("xs")]: {
            height: `${hash.walk('imgHeight.xs', props) || '100vh'}`,
        },
        [theme.breakpoints.up("xs")]: {
            height: `${hash.walk('imgHeight.sm', props) || '100vh'}`,
        },
        [theme.breakpoints.up("sm")]: {
            height: `${hash.walk('imgHeight.md', props) || '100vh'}`,
        },
        [theme.breakpoints.up("md")]: {
            height: `${hash.walk('imgHeight.lg', props) || '100vh'}`,
        },
        [theme.breakpoints.up("lg")]: {
            height: `${hash.walk('imgHeight.xl', props) || '100vh'}`,
        }
    }),

    cover: props => ({
        backgroundImage: `url(${config.S3Endpoint}${props.imgUrl})`,
        backgroundPosition: `${hash.walk('imgPosition.xl', props) || 'center'}`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0',
        right: '0',
        left: '0',
        bottom: '0',

        [theme.breakpoints.down("xs")]: {
            backgroundPosition: `${hash.walk('imgPosition.xs', props) || 'center'}`,
        },
        [theme.breakpoints.up("xs")]: {
            backgroundPosition: `${hash.walk('imgPosition.sm', props) || 'center'}`,
        },
        [theme.breakpoints.up("sm")]: {
            backgroundPosition: `${hash.walk('imgPosition.md', props) || 'center'}`,
        },
        [theme.breakpoints.up("md")]: {
            backgroundPosition: `${hash.walk('imgPosition.lg', props) || 'center'}`,
        },
        [theme.breakpoints.up("lg")]: {
            backgroundPosition: `${hash.walk('imgPosition.xl', props) || 'center'}`,
        },
    }),

    coverTitle: props => ({
        ...{...props.style.title}
    })

}));

export default (props) => {
    
    const classes = useStyles(props);

    useEffect(() => {
        if (!props.skipScroll) {
            window.scrollTo(0, 0);
        }
    }, [props]);

    return (
        <React.Fragment>
            <div className={classes.pageCoverSection}>
                <div className={classes.cover} />
                <div className={classes.coverTitle}>
                    {props.children}
                </div>
            </div>
        </React.Fragment>
    )
} 



// WEBPACK FOOTER //
// ./src/client/components/PageCover.js